


















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Slide, SlideAnswers, QuizSlideResult } from 'src/assets/AttendeeItemData'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import ButtonCheck from 'components/presenter/item/topic/viewer/ButtonCheck.vue'

@Component({
  components: {
    MarkdownViewerCrdt,
    ButtonCheck
  }
})
export default class ItemTopicViewerChoice extends Vue {
  response: { [key: string]: boolean } = {}

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonShowAlways!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  @Prop()
  readonly slide!: Json

  @Prop({ default: false })
  readonly keynote!: boolean

  @Prop()
  readonly seed!: string | undefined

  @Prop()
  readonly result!: QuizSlideResult | undefined

  @Prop({ default: () => { return {} } })
  readonly meta!: Json

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: { [key: string]: boolean }

  @Watch('value', { immediate: true })
  update (value: { [key: string]: boolean }) {
    this.response = value ? Object.assign({}, value) : {}
  }

  get text () {
    return this.slide?.text?.getText()
  }

  get answers () {
    const sorted = new SlideAnswers(this.slide as Slide, this.seed)
    return [...sorted.answers]
  }

  get size () {
    return this.$q.screen.lt.md ? 'md' : 'lg'
  }

  get canRespond () {
    return !(this.readonly || this.feedbackButtonOn)
  }

  toggle (id: string) {
    if (this.canRespond) {
      if (this.response[id]) {
        this.$delete(this.response, id)
      } else {
        if (!this.slide.multichoice) {
          this.response = {}
        }
        this.$set(this.response, id, true)
      }
      this.$emit('input', Object.keys(this.response).length ? this.response : undefined)
    }
  }
}
